export default function WhyMostTrainingsFail() {
  const differences = [
    {
      old: { title: 'Обучают улыбаться и говорить красивые фразы', desc: 'Шаблонные скрипты, заученные приветствия и дежурные улыбки. Клиенты чувствуют фальшь мгновенно — и доверие разрушается.' },
      new: { title: 'Меняем мышление, а не слова', desc: 'Учим понимать клиента, а не имитировать понимание. Когда сотрудник искренне заинтересован — это чувствуется без заученных фраз.' },
    },
    {
      old: { title: 'Дают теорию и красивые слайды', desc: 'Двухдневный семинар с конспектами, которые ложатся на полку. Через неделю сотрудники возвращаются к привычному поведению.' },
      new: { title: '80% времени — практика', desc: 'Реальные кейсы компании, ролевые упражнения, разбор записей звонков и переписок. Участники не слушают — они делают.' },
    },
    {
      old: { title: 'Одинаковая программа для всех', desc: 'Банки, производство, интернет-магазины — всем одно и то же. Без учёта специфики клиентов и бизнес-процессов компании.' },
      new: { title: 'Адаптация под конкретный бизнес', desc: 'Изучаем ваших клиентов, продукт, типовые ситуации. Программа строится под реальные вызовы вашей команды.' },
    },
    {
      old: { title: 'Нет внедрения — тренинг закончился и всё', desc: 'После тренинга — тишина. Никто не проверяет, применяют ли сотрудники новые навыки. Результат теряется за 2–3 недели.' },
      new: { title: 'Сопровождение после обучения', desc: 'Разбираем реальные коммуникации, поддерживаем в чате, корректируем. Навыки закрепляются, а не забываются.' },
    },
  ];

  const roadmap = [
    { title: 'Диагностика', desc: 'Анализ текущих коммуникаций: звонки, переписки, жалобы, отзывы. Интервью с сотрудниками и руководителями.' },
    { title: 'Практика', desc: 'Отработка навыков на реальных ситуациях компании. Никаких абстрактных примеров.' },
    { title: 'Реальные кейсы', desc: 'Разбор звонков, переписок и встреч участников. Детальная обратная связь.' },
    { title: 'Разбор коммуникаций', desc: 'Глубокий анализ: что сработало, что нет, как улучшить.' },
    { title: 'Внедрение', desc: 'Интеграция новых стандартов в ежедневную работу. Регламенты и алгоритмы.' },
    { title: 'Сопровождение', desc: 'Посттренинговая поддержка: аудит, чат, корректировка стратегии.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-close-circle-line"></i>
            Почему стандартные тренинги не работают
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему большинство тренингов по сервису не дают результата
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Стандартные сервисные тренинги учат улыбаться и говорить правильные слова. Но не меняют мышление сотрудников. Клиенты чувствуют разницу между скриптом и искренним отношением.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-16 space-y-6">
          {differences.map((item, i) => (
            <div key={i} className="grid md:grid-cols-2 gap-4">
              <div className="bg-red-50 rounded-xl p-5 md:p-6 border border-red-100">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
                    <i className="ri-close-line text-red-500 text-sm"></i>
                  </div>
                  <span className="text-xs font-semibold text-red-600 uppercase tracking-wider">Стандартный подход</span>
                </div>
                <h4 className="text-base font-semibold text-gray-900 mb-1.5">{item.old.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{item.old.desc}</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-5 md:p-6 border border-teal-100">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-check-line text-teal-600 text-sm"></i>
                  </div>
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wider">Наш подход</span>
                </div>
                <h4 className="text-base font-semibold text-gray-900 mb-1.5">{item.new.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{item.new.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto">
          <h3 className="text-xl font-bold text-gray-900 text-center mb-8">Как строится наша работа</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {roadmap.map((item, i) => (
              <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 transition-colors group text-center">
                <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto mb-3">
                  <span className="text-white font-bold text-sm">{i + 1}</span>
                </div>
                <h4 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}